export const checkMail = (val) => {
  let reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
  if (reg.test(val)) {
    return true
  } else {
    return false
  }
};

export const checkPassword = (val) => {
  if (val.length < 8) {
    return false
  } else {
    return true
  }
}

export const checkPasswordConfirmation = (val) => {
  if (val.length < 8) {
    return false;
  } else {
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/module/validation.js